/* src/app/components/shared/footer/footer.component.scss */
input:hover {
  background-color: #d4d4d4;
}
p,
h5,
li {
  font-size: 14px !important;
}
.footer .footer-widget a {
  font-size: 14px !important;
}
.footer .links-widget a:hover,
.footer .subscribe-widget a:hover,
.a-hover:hover {
  opacity: 0.6;
}
.footer-widget .logo {
  letter-spacing: normal;
  font-size: 24px !important;
  font-weight: 700;
  font-family: "IBM Plex Sans", sans-serif;
}
.btn-color {
  background-color: var(--theme-deafult-secondary) !important;
}
/*# sourceMappingURL=footer.component.css.map */
